import React from 'react';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { PilotPlanBanner } from '../PilotPlanBanner';

export const NofificationsBanners = () => {
    const { isPilotPlan } = useCurrentPlanStatus();

    if (isPilotPlan) {
        return <PilotPlanBanner />;
    }

    return null;
};
